import request from 'superagent';
import moment from 'moment';
import config from '../config';
import ArticleService from './article.js';


const data = (query) => {
  return ArticleService.dataWithQuery(query);
};

module.exports = {
  data() {
    return data();
  },

  dataWithQuery(query = {}) {
    return data(query);
  }
};



// WEBPACK FOOTER //
// ./src/services/search.js